export enum QuestionType {
    SingleSelection = 1,
    MultiSelection = 2,
    ImageWithSingleSelection = 3,
    ImageWithMultiSelection = 4,
    ParagraphWithSingleSelection = 5
}
export enum AdminType {
    SuperAdmin = 1,
    CompanyAdmin = 2,
    Admin = 3,
    HR = 4,
    Receptionist = 5,
}